// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M18 18.5V5.5M5.58561 13.2276L4.0039 18.5H4L5.58561 13.2276ZM5.58561 13.2276L7.90386 5.5H9.20386L11.5651 13.371M11.5651 13.371L13.1038 18.5H13.0999L11.5651 13.371ZM5.95381 13.371H11.1538","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai')
export default class AiIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai',
    }
  }
}
